import {TransformerInterface} from "./transformerInterface";
import {TimeFrameDTO} from "../domain/dtos/time-frame.dto";
import {TimeFrame} from "../domain/entities/time-frame.entity";
import {transformer} from "../decorators/transformer.decorator";
import {injectable} from "tsyringe";

@injectable()
@transformer({
    source: TimeFrame,
    target: 'dto'
})
export class TimeFrameToDtoTransformer implements TransformerInterface<TimeFrameDTO, TimeFrame> {

    public transform(inputObject: TimeFrame): Promise<TimeFrameDTO> {
        return Promise.resolve(<TimeFrameDTO>{
            uid: inputObject.uid,
            start: inputObject.start.toUTC().toSQL(),
            end: inputObject.end.toUTC().toSQL(),
            createdAt: inputObject.createdAt.toUTC().toSQL(),
            sorting: inputObject.sorting
        });
    }

}